'use client';

import React, { useMemo, useState } from 'react';
import { Box, Typography, Button } from '@mui/material';
import { AgGridReact } from 'ag-grid-react';

const StandardWallThicknessGrid = () => {
  const [isCollapsed, setIsCollapsed] = useState(false);

  const [rowData] = useState([
    { diameter: '6″', stdWt: 0.28 },
    { diameter: '8″', stdWt: 0.322 },
    { diameter: '10″', stdWt: 0.365 },
    { diameter: '12″', stdWt: 0.375 },
    { diameter: '16″', stdWt: 0.375 },
    { diameter: '20″', stdWt: 0.5 },
  ]);

  const columnDefs = useMemo(
    () => [
      {
        headerName: 'Pipe Diameter (in.)',
        field: 'diameter',
        width: 180,
        cellStyle: { backgroundColor: '#f0f0f0', color: '#333' },
        flex: 1,
      },
      {
        headerName: 'STD WT (in.)',
        field: 'stdWt',
        width: 180,
        cellStyle: { backgroundColor: '#f0f0f0', color: '#333' },
        flex: 1,
      },
    ],
    []
  );

  return (
    <Box mt={4}>
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        sx={{
          backgroundColor: '#5A7AA1',
          color: 'white',
          padding: '8px 16px',
          borderRadius: 1,
        }}
      >
        <Typography variant="h6">Standard Wall Thickness Table (6″–20″)</Typography>
        <Button
          size="small"
          variant="outlined"
          sx={{ color: 'white', borderColor: 'white' }}
          onClick={() => setIsCollapsed((prev) => !prev)}
        >
          {isCollapsed ? 'Expand' : 'Collapse'}
        </Button>
      </Box>

      {!isCollapsed && (
        <Box className="ag-theme-alpine" sx={{ height: 300, width: '100%', mt: 2 }}>
          <AgGridReact
            rowData={rowData}
            columnDefs={columnDefs}
            defaultColDef={{
              resizable: true,
              sortable: false,
              editable: false,
              cellStyle: { textAlign: 'left' },
            }}
            domLayout="autoHeight"
            suppressMovableColumns
          />
        </Box>
      )}
    </Box>
  );
};

export default StandardWallThicknessGrid;
